import * as React from "react";

import { AbsoluteModelPath } from "../../../../../Common/ModelPath/ModelPath";

export interface ValueLengthProps {
    bindingPath: AbsoluteModelPath;
    value?: string;
}

export function ValueLength(props: ValueLengthProps): JSX.Element {
    return <span>{props.value?.length ?? 0}</span>;
}
